// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1qtmj","errorLogs":"styles_errorLogs__1sZV7"};